<template>
  <el-dialog
    class="rc-dialog"
    :title="title"
    :visible.sync="showDialog.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    width="54%"
  >
    <el-form
      ref="rForm"
      :model="ruleform"
      size="small"
      :rules="rules"
      label-position="right"
      label-width="100px"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item label="类型：" prop="organizerType">
            <el-select
              v-model="ruleform.organizerType"
              placeholder="请选择类型"
              style="width: 100%"
              :disabled="item && item.uuid"
              clearable
            >
              <el-option
                v-for="item in typeData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="item.paramKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="单位名称：" prop="organizerName">
            <el-input
              v-model="ruleform.organizerName"
              placeholder="请输入单位名称"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="标签：" prop="organizerTag" v-if="ruleform.organizerType !== '2'">
            <el-select
              v-model="ruleform.organizerTag"
              placeholder="请选择标签"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in tagData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="item.paramKey"
              ></el-option>
            </el-select>
            <span>提示：该标签用于大屏数据统计，区分对应单位主办的班级是否省委组织部调训、市委组织部调训。<br/>如果两者都不是，则不需要设置。</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn class="czButn" @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import rulesFactory from "@/utils/rules";
import {
  classOrganizerUpdate,
  classOrganizerSave
} from "@/api/rescategory";
import { getSysParamByTypes, getBusinessParamByTypes } from "@/api/sysParam";

export default {
  name: "curd",
  components: { butn },
  props: {
    showDialog: {
      type: Object,
      default: function() {
        return {
          flag: false,
        };
      }
    },
    item: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      title: "新增/编辑",
      ruleform: {
        organizerType: "",
        organizerName: "",
        organizerTag: ""
      },
      typeData: [],
      tagData: [],
      rules: {
        organizerName: [
          rulesFactory.required("请输入单位名称"),
          rulesFactory.size("最多输入50个字", 0, 50)
        ],
        organizerType: [
          rulesFactory.required("请选择类型"),
        ],
      }
    };
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.typeData = res.data["ORGANIZER_TYPE"];
        // this.tagData = res.data["ORGANIZER_TAG"];
      });
    },
    // 获取多个数据字典
    getBusinessParamByTypes(types) {
      getBusinessParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.tagData = res.data["ORGANIZER_TAG"];
      });
    },
    closeDialog() {
      this.$emit("closeDialog", false);
    },
    submitForm() {
      this.$refs["rForm"].validate(valid => {
        if (valid) {
          if (this.ruleform.uuid == null) {
            // 新增
            classOrganizerSave(this.ruleform).then(res => {
              if (res && res.code == 0) {
                this.closeDialog();
                this.$emit("closeDialog", true);
              }
            });
          } else {
            //编辑
            classOrganizerUpdate(this.ruleform).then(res => {
              if (res && res.code == 0) {
                this.closeDialog();
                this.$emit("closeDialog", true);
              }
            });
          }
        }
      });
    }
  },
  created() {
    this.getSysParamByTypes(["ORGANIZER_TYPE"]);
    this.getBusinessParamByTypes(["ORGANIZER_TAG"]);
    if (this.item.uuid) {
      this.ruleform = JSON.parse(JSON.stringify(this.item));
    }
  },
};
</script>

<style lang="scss" scoped></style>
